<template>
  <div style="width: 100%;">
    <v-card :style="{ backgroundColor: $ajustes.colorElemento, height: '225px', width: '100%' }" elevation="1"
      class="line d-flex center" :disabled="loading" :loading="loading">
      <!-- Izquierda: imagen -->
      <!-- <div style="width: 130px;">
    <v-img
    :src="`${$env.pathImg}/${propFicha.imagen_ruta}`"
    cover
    height="100%"
    class="pa-0"
    style="overflow: hidden; flex-shrink: 0;"
  ></v-img>
</div> -->
      <div style="width: 130px;">
        <v-avatar size="120" class="elevation-2 ma-2" style="border: 4px solid white;">
          <v-img :src="`${$env.pathImg}/${propFicha.imagen_ruta}`" cover></v-img>
        </v-avatar>
      </div>
      <!-- Derecha: contenido -->
      <v-container class="pa-2 pt-0 pl-5">
        <div style="height: 170px;overflow: hidden;">
          <h1 class="mt-1"
            style="text-align: left; line-height: 1.2em; font-size: 11pt; margin: 0; font-weight: normal;">
            {{ propFicha.rol }}
          </h1>
          <h1 style="text-align: left; line-height: 1.2em; font-size: 14pt; margin: 0;">
            {{ propFicha.nombres }}
          </h1>
          <h1 class="mb-1"
            style="text-align: left; line-height: 1.2em; font-size: 11pt; margin: 0; font-weight: normal">
            {{ propFicha.titulo }}
          </h1>
          <span class="mt-2 mb-1" style="font-size: small; height: 130px; overflow: hidden; white-space: pre-wrap;line-height: 0.5">
            {{ propFicha.mensaje }}
          </span>
        </div>
        <br>
        <br>
        <div class="absolute bottom mb"><strong><a style="font-size: small;color: blue;" @click="dialogo = true">Ver
              mensaje</a>
              <br>
            <a style="font-size: small;color: blue;text-decoration: none" target="_blank"
              :href="propFicha.enlacecv">Ver
              curriculum</a>
          </strong>
        </div>

      </v-container>
    </v-card>
    <v-dialog v-model="dialogo" width="650px" persistent>
      <v-card style="padding: 15px">
        <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
          @click="dialogo = false">mdi-close-circle</v-icon>
        <div class="container">
          <v-row>
            <v-col lg="5" cols="12">
              <div style="width: 180px;">
                <v-avatar size="180" class="elevation-2 ma-2" style="border: 4px solid white;">
                  <v-img :src="`${$env.pathImg}/${propFicha.imagen_ruta}`" cover></v-img>
                </v-avatar>
              </div>
              <h1 class="mt-1"
                style="text-align: left; line-height: 1.2em; font-size: 11pt; margin: 0; font-weight: normal;">
                {{ propFicha.rol }}
              </h1>
              <h1 style="text-align: left; line-height: 1.2em; font-size: 14pt; margin: 0;">
                {{ propFicha.nombres }}
              </h1>
              <h1 class="mb-1"
                style="text-align: left; line-height: 1.2em; font-size: 11pt; margin: 0; font-weight: normal">
                {{ propFicha.titulo }}
              </h1>
            </v-col>
            <v-col lg="7" cols="12">
              <h1 class="mb-2">MENSAJE</h1>
              <div style="min-height: 50px; overflow: auto;">
                <span class="mt-2 mb-1" style="font-size: small;white-space: pre-wrap;line-height: 1.0;">
                  {{ propFicha.mensaje }}
                </span>
              </div>
            </v-col>
          </v-row>
          <br>
          <div><strong><a style="font-size: small;color: blue;" target="_blank" :href="propFicha.enlacecv">Ver
                Curriculum</a> </strong>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    propFicha: { type: Object },
  },
  data() {
    return {
      loading: false,
      dialogo: false
    };
  },
  mounted() {
  },

  created() { },
  computed: {},
  methods: {
  },
  continuar() { },
  close() { },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
